import { AnyAction } from 'redux';
import { GET_TOGGLER_SUCCESS, togglerType } from '../types/mdms';
import { LOGOUT_SUCCESS } from '../types/auth';
import {
  CREATE_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_Fatca_SUCCESS,
} from '../types/application';
import { FatcaMdms } from '../types/api-types';

export type mdmsProp = {
  Fatca: FatcaMdms;
  toggler: togglerType;
};

const initialState: mdmsProp = {
  Fatca: {
    fatca_questions: [],
  },
  toggler: {
    fatcaMasterDataFeatureToggle: {},
  },
};

export const mdmsDataReducer = (state = initialState, action: AnyAction): mdmsProp => {
  switch (action.type) {
    case GET_Fatca_SUCCESS:
      return { ...state, Fatca: action.body };
    case LOGOUT_SUCCESS:
    case GET_ALL_APPLICATION_SUCCESS:
    case CREATE_APPLICATION_SUCCESS: {
      return { ...initialState };
    }
    case GET_TOGGLER_SUCCESS: {
      return { ...state, toggler: action.body };
    }
    default:
      return state;
  }
};
